/**
 * Legacy Modal-based confirm — compatibility wrapper for signed-off chrome
 * surfaces (ThreadHistorySidebar). Admin call sites use design-system
 * `ConfirmDialog` directly.
 */

import type { ReactNode } from 'react';

import { Modal } from '@/design-system';
import { BUTTON_DANGER, BUTTON_GHOST_ADMIN, BUTTON_PRIMARY } from '@/shared/ui-class';

export function ConfirmModal({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  cancelLabel = 'Cancel',
  tone = 'default',
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  tone?: 'default' | 'danger';
  onConfirm: () => void;
}) {
  return (
    <Modal open={open} onOpenChange={onOpenChange} title={title}>
      <div className="space-y-4">
        <div className="text-sm text-muted">{description}</div>
        <div className="flex flex-wrap justify-end gap-2">
          <button
            type="button"
            className={BUTTON_GHOST_ADMIN}
            onClick={() => onOpenChange(false)}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={tone === 'danger' ? BUTTON_DANGER : BUTTON_PRIMARY}
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
